import * as React from 'react'
import { find, includes } from 'lodash'
import Error from 'next/error'

import Meta from '~/components/meta'
import paymentMethodsQuery from '~/gql/queries/payment-methods'
import EmbededPdfScreen from '~/screens/embeded-pdf'
import { getMetaInfo, redirectTo } from '~/utils'
import { httpStatusCodes } from '~/utils/constants'
import type { GetMetaInfoResult } from '~/utils/get-meta-info'

interface TermsAndConditionsPageProps {
  metaInfo: GetMetaInfoResult
  url: string
  paymentMethodName: string
  isInvalidPaymentMethod: boolean
}

function TermsAndConditionsPage(props: TermsAndConditionsPageProps) {
  const { metaInfo, url, paymentMethodName, isInvalidPaymentMethod } = props

  let title = 'Términos y Condiciones'

  if (paymentMethodName) {
    title += ` - ${paymentMethodName}`
  }

  if (isInvalidPaymentMethod) {
    return <Error statusCode={httpStatusCodes.NOT_FOUND} />
  }

  return (
    <>
      <Meta {...metaInfo} title={title} noRobots />
      <EmbededPdfScreen url={url} />
    </>
  )
}

const getPaymentMethod = async (context: PageContext) => {
  const { paymentMethodSlug } = context.query

  const response = await context.apolloClient.query({
    query: paymentMethodsQuery,
  })

  const { paymentMethods } = response.data.vendor

  return find(paymentMethods, { slug: paymentMethodSlug })
}

TermsAndConditionsPage.getInitialProps = async (
  context: PageContext<{ paymentMethodSlug: string }>,
): Promise<TermsAndConditionsPageProps | void> => {
  const { paymentMethodSlug } = context.query

  const paymentMethod = await getPaymentMethod(context)

  const hasSlug = paymentMethodSlug !== undefined

  const isInvalidPaymentMethod = hasSlug && !paymentMethod

  if (isInvalidPaymentMethod && context.res) {
    // eslint-disable-next-line no-param-reassign
    context.res.statusCode = httpStatusCodes.NOT_FOUND
  }

  const legalTermsUrl = paymentMethod?.settings?.legalTermsUrl ?? context.vendor.legalTermsUrl

  if (!legalTermsUrl) {
    redirectTo('/', context)

    return
  }

  if (includes(legalTermsUrl, 'cloudinary')) {
    return {
      url: legalTermsUrl,
      isInvalidPaymentMethod,
      metaInfo: getMetaInfo(context),
      paymentMethodName: paymentMethod?.name,
    }
  }

  if (context.res) {
    context.res.redirect(legalTermsUrl)
  } else if (typeof window !== 'undefined') {
    window.location.href = legalTermsUrl
  }
}

export default TermsAndConditionsPage
